import { PropsWithChildren } from 'react';
import { MdArrowBackIosNew, MdArrowForwardIos } from 'react-icons/md';
import { IconButton } from '@ds';
import { formatDate } from '@/utils/helpers';

type MonthNavigationButtonsProps = PropsWithChildren<{
  selectedDate: Date;
  /**
   * The period label (e.g. "Period 13 · 2026"). Overrides the default "MMMM yyyy" heading.
   * When `dateRange` is also set, this is the HEADING and `dateRange` drops to the supporting
   * line below it: the period number is what identifies the window, and the date range grounds
   * it in the calendar.
   */
  label?: string;
  /** The period's date range (e.g. "13 August – 9 September"), rendered as the supporting line. */
  dateRange?: string | null;
  onMonthPrev: () => void;
  onMonthNext: () => void;
}>;

export const MonthNavigationButtons = ({
  selectedDate,
  label,
  dateRange,
  onMonthPrev,
  onMonthNext,
  children,
}: MonthNavigationButtonsProps) => {
  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <div className="flex gap-1">
          <IconButton
            disableRipple
            variant="light"
            size="md"
            startContent={<MdArrowBackIosNew size={16} />}
            onPress={onMonthPrev}
          />
          <IconButton
            disableRipple
            variant="light"
            size="md"
            startContent={<MdArrowForwardIos size={16} />}
            onPress={onMonthNext}
          />
        </div>
        {label && dateRange ? (
          <div className="flex flex-col">
            <h3>{label}</h3>
            {dateRange && <span className="text-hxs font-secondary text-base-15">{dateRange}</span>}
          </div>
        ) : (
          <h1>{formatDate(selectedDate, 'MMMM yyyy')}</h1>
        )}
      </div>
      {children}
    </div>
  );
};
